<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container" :style="setStyleGlobal">

          <div class="modal-header">
            <slot name="header">
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              Body
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              Footer
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'global-modal',

  props: {
    width: {
      type: Number
    },

    height: {
      type: Number
    }
  },

  computed: {
    setStyleGlobal () {
      return 'width:' + this.width + '% !important;height:' + this.height + '% !important;'
    }
  }
}
</script>

<style scoped>
  a {
    cursor: pointer;
  }

  .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 900px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
  height: auto;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  .modalEditRoles .modal-wrapper .modal-container{
    overflow-y: auto;
    height: 650px;
  }

  @media (min-height: 940px){
    .modalEditRoles .modal-wrapper .modal-container{
      overflow-y: auto;
      height: 800px;
    }
  }

  .modalEditModels .modal-wrapper .modal-container{
    overflow-y: auto;
    width: 60% !important;
    height: 650px;
  }

  @media (min-height: 940px){
    .modalEditModels .modal-wrapper .modal-container{
      width: 60% !important;
      overflow-y: auto;
      height: 860px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/modals/GlobalModal.vue